// tslint:disable-next-line:no-any
export const execAll = <T extends (...args: any[]) => any>(
  ...fns: readonly T[]
) => (...params: unknown[]) => {
  for (const fn of fns) {
    fn(...params);
  }
};
